import { FC } from 'react';

import { Fade } from '@chakra-ui/react';

import { useSettings } from '~/shared/hooks/settings';

import { CharacterImageDesktop, CharacterImageMobile } from './styles';

interface SideBarCharacterProps {
  isVisible: boolean;
}

export const SideBarCharacter: FC<SideBarCharacterProps> = ({ isVisible }) => {
  const { settings } = useSettings();
  const { theme } = settings || {};
  const {
    mobileSidebar: sideBarMobileCharacter,
    desktop: sideBarDesktopCharacter,
  } = theme?.characters || {};

  return isVisible ? (
    <Fade in>
      <CharacterImageMobile src={sideBarMobileCharacter} alt="..." />
      <CharacterImageDesktop src={sideBarDesktopCharacter} alt="..." />
    </Fade>
  ) : null;
};
